export default {
  SET_ALERTS(state, alerts) {
    state.alerts = alerts;
  },

  SET_ALERT(state, updatedAlert) {
    const index = state.alerts.collection.findIndex((alert) => alert.id === updatedAlert.id);

    if (index >= 0) {
      state.alerts.collection.splice(index, 1, updatedAlert);
    }
  },

  SET_NEWS(state, newsItems) {
    state.newsItems = newsItems;
  },

  SET_CIRCLES(state, circles) {
    state.circles = circles;
  },

  SET_DOUGHNUTS(state, doughnuts) {
    this._vm.$set(state, "doughnuts", doughnuts);
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PYRAMIDS(state, pyramids) {
    state.pyramids = pyramids;
  },

  SET_COMPUTER_EVOLUTION_STATS(state, computerEvolutionStats) {
    state.computerEvolutionStats = computerEvolutionStats;
  },

  SET_ALERT_EVOLUTION_STATS(state, alertEvolutionStats) {
    state.alertEvolutionStats = alertEvolutionStats;
  },

  SET_ALERTS_PER_DAY_EVOLUTION_STATS(state, alertsPerDayEvolutionStats) {
    state.alertsPerDayEvolutionStats = alertsPerDayEvolutionStats;
  },

  SET_AGENTS_PER_DAY_EVOLUTION_STATS(state, agentsPerDayEvolutionStats) {
    state.agentsPerDayEvolutionStats = agentsPerDayEvolutionStats;
  },

  SET_VACCINE_EVOLUTION_STATS(state, vaccineEvolutionStats) {
    state.vaccineEvolutionStats = vaccineEvolutionStats;
  },

  SET_AGENCY_EVOLUTION_STATS(state, agencyEvolutionStats) {
    state.agencyEvolutionStats = agencyEvolutionStats;
  },

  SET_ALERTS_PER_VACCINE_EVOLUTION_STATS(state, alertsPerVaccineEvolutionStats) {
    state.alertsPerVaccineEvolutionStats = alertsPerVaccineEvolutionStats;
  },

  SET_IS_STATS_EVOLUTION_ERROR(state, value) {
    state.isStatsEvolutionError = value;
  },
};
